<template>
    <CModal
        size="xl"
        alignment="center"
        :visible="showModal"
        @close="getDayOff"
    >
        <CModalHeader>
            <CModalTitle>{{ $t('base.getDayOff') }}</CModalTitle>
        </CModalHeader>

        <CModalBody>
            <CButton
                v-show="defaultState"
                @click.prevent="defaultState = false"
                color="primary"
                size="sm"
                class="float-end"
                >{{ $t('sidebar.getDayOff') }}</CButton
            >
            <VacationTable v-show="defaultState" />
            <div class="days-count">
                {{ $t('profile.usedDays') }}: {{getVacationsCount.day_off}}
            </div>
            <CForm v-show="!defaultState">
                <div class="mb-3">
<!--                    <CFormLabel>{{-->
<!--                        $t('getVacation.form.chooseDuration')-->
<!--                    }}</CFormLabel>-->
<!--                    <select-->
<!--                        ref="duration"-->
<!--                        v-model="v$.duration.$model"-->
<!--                        @change="checkDuration"-->
<!--                        class="select"-->
<!--                    >-->
<!--                        <option value="">-->
<!--                            {{ $t('getVacation.form.duration') }}-->
<!--                        </option>-->
<!--                        <option value="period">-->
<!--                            {{ $t('getVacation.form.period') }}-->
<!--                        </option>-->
<!--                        <option value="day">-->
<!--                            {{ $t('getVacation.form.day') }}-->
<!--                        </option>-->
<!--                    </select>-->

<!--                    <small-->
<!--                        v-if="v$.duration.$error"-->
<!--                        class="helper-text invalid"-->
<!--                        >{{ $t('getVacation.form.chooseDuration') }}</small-->
<!--                    >-->
                </div>







                <div v-if="durationType === 'day'" class="mb-3">
                    <CFormLabel>{{ $t('calendar.form.date') }}</CFormLabel>
                    <!-- <input
                        class="date-input"
                        v-model="date"
                        type="date"
                        ref="date"
                        :min="currentDate"
                    /> -->

                    <Datepicker
                        ref="date"
                        :min-date="new Date()"
                        v-model="date"
                        :disabled-week-days="[6,0]"
                        :highlight-week-days="[6, 0]"
                        :enable-time-picker="false"
                        teleport-center
                    ></Datepicker>

                    <small
                        v-if="v$.date.$dirty && v$.date.$error"
                        class="helper-text invalid"
                        >{{ $t('calendar.form.dateValidation') }}</small
                    >
                    <CFormCheck id="flexCheckDefaultVModel" class="checkbox-pay" :label="$t('hr.withoutPay')" v-model="withoutPay" />
                </div>











                <div v-if="durationType === 'period'" class="mb-3">
                    <CFormLabel>{{
                        $t('calendar.form.dateBeginning')
                    }}</CFormLabel>
                    <!-- <input
                        @change="setMinDate"
                        :min="minDate"
                        :max="maxDate"
                        v-model="start"
                        class="date-input"
                        type="date"
                        ref="start"
                    /> -->

                    <Datepicker
                        @update:modelValue="setMinDate"
                        v-model="start"
                        :min-date="minDate"
                        :max-date="maxDate"
                        ref="start"
                        :enable-time-picker="false"
                        teleport-center
                    ></Datepicker>

                    <small
                        v-if="v$.start.$dirty && v$.start.$error"
                        class="helper-text invalid"
                        >{{
                            $t('calendar.form.dateBeginningValidation')
                        }}</small
                    >
                </div>

                <div v-if="durationType === 'period'" class="mb-3">
                    <CFormLabel>{{
                        $t('calendar.form.dateEnding')
                    }}</CFormLabel>

                    <!-- <input
                        :min="minDateSecondary"
                        @change="setMaxDate"
                        v-model="end"
                        class="date-input"
                        type="date"
                        ref="end"
                    /> -->

                    <Datepicker
                        @update:modelValue="setMaxDate"
                        v-model="end"
                        :min-date="minDateSecondary"
                        ref="end"
                        :enable-time-picker="false"
                        teleport-center
                    ></Datepicker>

                    <small
                        v-if="v$.end.$dirty && v$.end.$error"
                        class="helper-text invalid"
                        >{{ $t('calendar.form.dateEndingValidation') }}</small
                    >
                </div>
            </CForm>
        </CModalBody>

        <CModalFooter v-show="!defaultState">
            <CButton color="secondary" size="sm" @click="getDayOff">
                {{ $t('general.close') }}
            </CButton>
            <CButton
                @click="handleDateSubmit"
                :disabled="requestStatus"
                color="primary"
                size="sm"
                >{{ $t('general.confirm') }}</CButton
            >
        </CModalFooter>
    </CModal>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import VacationTable from '@/components/vacation/VacationTable.vue'
import { reactive, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import fireSwal from '@/helpers/fireSwal'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default {
    name: 'GetDayOffModal',
    components: {
        VacationTable,
        Datepicker,
    },
    emits: ['getDayOff', 'closeDayOffModal'],
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
    },
    setup() {
        const store = useStore()
        const state = reactive({
            defaultState: false,
            currentDate: new Date().toISOString().split('T')[0],
            minDate: new Date().toISOString().split('T')[0],
            maxDate: null,
            tableData: computed(() => store.getters['events/getVacations']),
            user: computed(
                () => store.getters['authorization/getUserNickname'],
            ),
            currentUser: computed(
                () => store.getters['authorization/getCurrentUser'],
            ),
        })

        return { ...toRefs(state), store }
    },
    data() {
        return {
            withoutPay: false,
            dateErrors: [],
            v$: useVuelidate(),
            type: '',
            duration: '',
            start: null,
            end: null,
            minDate: new Date(),
            date: null,
            durationType: 'day',
            requestStatus: false,
            minDateSecondary: new Date(),
        }
    },
    validations() {
        return {
            duration: { required },
            type: { required },
            date: { required },
            start: { required },
            end: { required },
        }
    },

    computed: {
        getVacationsCount() {
            return this.$store.getters['hr/getVacationsCount']
        }
    },
    methods: {
        getVacation() {
            this.$emit('getVacation', false)
        },
        closeVacationModal() {
            this.defaultState = true
        },
        checkDuration() {
            this.durationType = this.$refs.duration.value
        },
        setMinDate(val) {
            this.minDateSecondary = val
        },
        setMaxDate(val) {
            this.maxDate = val
        },
        getDayOff() {
            this.requestStatus = false
            this.date = null
            this.start = null
            this.end = null
            this.durationType = 'day'
            this.duration = ''
            this.minDate = new Date().toISOString().split('T')[0]
            this.minDateSecondary = new Date()
                .toISOString()
                .split('T')[0]
            this.maxDate = null
            this.$emit('getDayOff', false)
        },
        handleDateSubmit() {
            this.dateErrors = []
            this.v$.$silentErrors.forEach((item) => {
                this.dateErrors.push(item.$property)
            })

            if (
                (this.v$.$invalid &&
                    (this.dateErrors.indexOf('start') !== -1 ||
                        this.dateErrors.indexOf('end') !== -1) &&
                    this.durationType === 'period') ||
                (this.v$.$invalid &&
                    this.dateErrors.indexOf('date') !== -1 &&
                    this.durationType === 'day')
            ) {
                this.v$.$touch()
                return
            }

            this.requestStatus = true

            this.$store
                .dispatch(`hr/addDayOff`, {
                    form: {
                        start:
                            this.durationType === 'period'
                                ? new Date(this.start)
                                : new Date(this.date),
                        end:
                            this.durationType === 'period'
                                ? new Date(this.end)
                                : new Date(this.date),
                        user_id: Number(this.currentUser.id),
                        active: 'pending',
                        date:
                            this.durationType === 'day'
                                ? new Date(this.date)
                                : new Date(this.start),
                        without_pay: this.withoutPay
                    },
                    id: this.currentUser.id,
                })
                .then(() => {
                    this.$emit('closeDayOffModal', false)
                    fireSwal(this.$t('notification.DayOffIsCreated'), 'success')
                    this.withoutPay = false
                    this.requestStatus = false
                    this.date = null
                    this.start = null
                    this.end = null
                    this.durationType = 'day'
                    this.duration = ''
                    this.minDate = new Date().toISOString().split('T')[0]
                    this.minDateSecondary = new Date()
                        .toISOString()
                        .split('T')[0]
                    this.maxDate = null
                    //this.type = this.$t('dashboard.bonusForm.chooseWorker')
                })
                .catch(() => {
                    this.requestStatus = false
                    // this.defaultState = true
                    // this.date = null
                    // this.start = null
                    // this.end = null
                    this.durationType = 'day'
                    this.duration = ''
                    this.minDate = new Date().toISOString().split('T')[0]
                    this.minDateSecondary = new Date()
                        .toISOString()
                        .split('T')[0]
                    this.maxDate = null

                    fireSwal(
                        this.$t(`notification.DayOffIsNotCreated`),
                        'error',
                    )
                })
        },
    },
}
</script>

<style lang="scss">
.checkbox-pay {
    margin-top: 20px;
}
.checkbox-input {
    &-wrapper {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    &-item {
        margin-right: 8px;
    }

    &-label {
        margin-bottom: 0;
    }
}
</style>
